
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
export default {
  name: 'ThemeSearch',
  data() {
    return {
      keyword: '',
      listbackShow: false,
    }
  },
  computed: {
    ...mapState('theme', ['themeList']),
    ...mapState('modal', ['alertShow']),
  },
  watch: {
    themeList() {
      if (this.themeList.totalCount === 0) {
        this.emptySearch('해당 단어관련 테마가 없습니다.')
        this.keyword = ''
      }
    },
  },
  methods: {
    ...mapActions('theme', ['GET_THEMELIST']),
    ...mapActions('theme', ['GET_THEMESEARCH']),
    ...mapActions('modal', ['SHOW_ALERT', 'SHOW_FIND_ID']),

    emptySearch(value) {
      this.SHOW_ALERT({ content: value })
    },

    findId() {
      this.SHOW_FIND_ID()
    },

    themeSearch() {
      event.preventDefault()
      if (this.alertShow === true){
        this.keyword = ''
      }
      else if(this.alertShow === false){
        if (this.keyword.trim() === '') {
          this.emptySearch('검색할 테마를 입력해주세요.')
          this.keyword = ''
          // console.log('!this.listb', this.listbackShow)
          this.onClickThemeDB()
        } else {
          console.log('!this.listbackShow', !this.listbackShow)
          this.GET_THEMESEARCH(this.keyword.trim())
          if (!this.listbackShow) {
            this.listbackShow = true
          }
        }
      }
    },
    onClickThemeAll() {
      this.$router.push('/Theme/ThemeDB/ThemeAll')
    },
    onClickThemeDB() {
      this.params = { pageNo: 1, countByPage: 25 }
      this.keyword = ''
      this.GET_THEMELIST(this.params)
      if (this.listbackShow) {
        this.listbackShow = false
      }
    },
  },
}
